// [ai-generated-code]
import { TableColumnsSetting } from '@/interfaces/table-setting';
import { VehicleRegistryModel } from '@/models/vehicle-registry/vehicle-registry.model';

export class VehicleRegistryTableSettings {
  public static getColumnsSetting(): TableColumnsSetting<keyof VehicleRegistryModel> {
    return [
      {
        name: 'id',
        text: 'ID',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'codiceMarca',
        text: 'Cod. marca',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'dataImmatricolazione',
        type: 'date',
        text: 'Data immatricolazione',
        filter: {
          type: 'dateRange',
        },
      },
      {
        name: 'telaio',
        text: 'Telaio',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'targa',
        text: 'Targa',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'modello',
        text: 'Modello',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'nrBpCliente',
        text: 'nr Bp cliente',
        filter: {
          type: 'number',
        },
      },
      {
        name: 'denominazioneCliente',
        text: 'Denominazione cliente',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'nrBpProprietario',
        text: 'nr Bp proprietario',
        filter: {
          type: 'number',
        },
      },
      {
        name: 'denominazioneProprietario',
        text: 'Denominazione proprietario',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'nrBpUtilizzatore',
        text: 'nr Bp utilizzatore',
        filter: {
          type: 'number',
        },
      },
      {
        name: 'denominazioneUtilizzatore',
        text: 'Denominazione utilizzatore',
        filter: {
          type: 'input',
        },
      },
    ];
  }
}
